import { NgModule,
         ApplicationRef }             from '@angular/core';
import { Compiler,
         LOCALE_ID }                  from '@angular/core';
import { BrowserModule }              from '@angular/platform-browser';
import { NoopAnimationsModule }       from '@angular/platform-browser/animations';
import { Http,
         HttpModule,
         RequestOptions }             from '@angular/http';
import { FormsModule,
         ReactiveFormsModule }        from '@angular/forms';
import { MatDatepickerModule,
         MatNativeDateModule,
         MatSidenavModule,
         MatSelectModule,
         MatRadioModule,
         MatProgressSpinnerModule,
         MatSnackBarModule,
         MatInputModule,
         MatCheckboxModule,
         MatButtonModule,
         MatTabsModule,
         MatIconModule,
         MatDialogModule,
         MatCardModule,
         MatListModule,
         MAT_PLACEHOLDER_GLOBAL_OPTIONS,
         MAT_DATE_LOCALE,
         MAT_DATE_FORMATS,
         MatDateFormats,

         MatAutocompleteModule,
        //  MatFormFieldModule,
        //  MatSliderModule,
        //  MatSlideToggleModule,
        //  MatMenuModule,
        //  MatToolbarModule,
        //  MatGridListModule,
        //  MatStepperModule,
        //  MatExpansionModule,
        //  MatButtonToggleModule,
        //  MatChipsModule,
        //  MatProgressBarModule,
        //  MatTooltipModule,
        MatTableModule,
        MatSortModule,
        //  MatPaginatorModule

        }              from '@angular/material';
import { FlexLayoutModule  }          from '@angular/flex-layout';
import { BrowserAnimationsModule }    from '@angular/platform-browser/animations';

import { AuthHttp,
         AuthConfig }                 from 'angular2-jwt';
import { AuthGuard }                  from './common/auth.guard';
import { Globals }                    from './common/globals';
import { AuthService }                from './shared/auth.service';
import { AppComponent }               from './app.component';
import { BusListComponent }           from './bus-list/bus-list.component';
import { BusDialogComponent }         from './bus-dialog/bus-dialog.component';
import { BusRouteListComponent }      from './bus-route-list/bus-route-list.component';
import { BusRouteDialogComponent }    from './bus-route-dialog/bus-route-dialog.component';
import { HomeComponent }              from './home/home.component';
import { MonitoringComponent }        from './monitoring/monitoring.component';
import { OrderLogisticalComponent }   from './order-logistical/order.component';
import { EetComponent }               from './eet/eet.component';
import { KitchenListComponent }       from './kitchen-list/kitchen-list.component';
import { KitchenDialogComponent }     from './kitchen-dialog/kitchen-dialog.component';
import { TrainListComponent }         from './train-list/train-list.component';
import { TrainCycleListComponent }    from './train-cycle-list/train-cycle-list.component';
import { TrainDialogComponent }       from './train-dialog/train-dialog.component';
import { TrainCycleDialogComponent }  from './train-cycle-dialog/train-cycle-dialog.component';
import { TrainCycleSortDialogComponent } from './train-cycle-sort-dialog/train-cycle-sort-dialog.component';
import { PeakListComponent }          from './peak-list/peak-list.component';
import { PeakDialogComponent }        from './peak-dialog/peak-dialog.component';
import { PeakCopyDialogComponent }    from './peak-copy-dialog/peak-copy-dialog.component';
import { PeakImportDialogComponent }  from './peak-import-dialog/peak-import-dialog.component';
import { ProductListComponent }       from './product-list/product-list.component';
import { ProductDialogComponent }     from './product-dialog/product-dialog.component';
import { ProductImportDialogComponent}from './product-import-dialog/product-import-dialog.component';
import { ProductImportErrorOverviewComponent } from './product-import-error-overview/product-import-error-overview.component';
import { UserListComponent }          from './user-list/user-list.component';
import { UserDialogComponent }        from './user-dialog/user-dialog.component';
import { CompanyListComponent }       from './company-list/company-list.component';
import { CompanyDialogComponent }     from './company-dialog/company-dialog.component';
import { SupplierListComponent }      from './supplier-list/supplier-list.component';
import { SupplierDialogComponent }    from './supplier-dialog/supplier-dialog.component';
import { GridTemplateComponent }      from './common/grid.template.component';
import { FileUploadComponent }        from './common/file-upload.component';
import { SavingDialogComponent }      from './common/saving-dialog.component';
import { LoadingDialogComponent }     from './common/loading-dialog.component';
import { ReceiptDialogComponent }     from './receipt-dialog/receipt-dialog.component';
import { PdfLinkComponent }           from './common/pdf-link.component';
import { LoginComponent }             from './login/login.component';
import { MenuComponent }              from './menu/menu.component';

import { BusService }                 from './shared/bus.service';
import { BusRouteService }            from './shared/bus-route.service';
import { KitchenService }             from './shared/kitchen.service';
import { TrainService }               from './shared/train.service';
import { TrainCycleService }          from './shared/train-cycle.service';
import { TrainCycleExceptionService } from './shared/train-cycle-exception.service';
import { PeakService }                from './shared/peak.service';
import { SupplierService }            from './shared/supplier.service';
import { CompanyService }             from './shared/company.service';
import { UserService }                from './shared/user.service';
import { ProductService }             from './shared/product.service';
import { ReportingService }           from './shared/reporting.service';
import { UploadService }              from './shared/upload.service';
import { MonitoringService }          from './shared/monitoring.service';
import { OrderLogisticalService }     from './shared/order-logistical.service';
import { CurrencyService }            from './shared/currency.service';
import { routing }                    from './app.routing';
import { Ng2PaginationModule }        from 'ng2-pagination';
import { ChartsModule }               from 'ng2-charts';

import { removeNgStyles,
         createNewHosts }             from '@angularclass/hmr';

import { WMatTimePickerComponent,
         WTimeDialogComponent,
         WClockComponent,
         WTimeComponent }             from './common/time-control';
import { HolidayExceptionListComponent } from './holiday-exception-list/holiday-exception-list.component';
import { HolidayExceptionDialogComponent } from './holiday-exception-dialog/holiday-exception-dialog.component';
import { HolidayExceptionService } from './shared/holiday-exception.service';
import { SettingListComponent } from './setting-list/setting-list.component';
import { SettingService } from './shared/setting.service';
import { SettingDialogComponent } from './setting-dialog/setting-dialog.component';
import { TrainCycleProductDialogComponent } from './train-cycle-product-dialog/train-cycle-product-dialog.component';
import { TrainCycleProductService } from './shared/train-cycle-product.service';
import { TrainClassListComponent } from './train-class-list/train-class-list.component';
import { TrainClassDialogComponent } from './train-class-dialog/train-class-dialog.component';
import { TrainClassService } from './shared/train-class.service';
import { TrainPartDialogComponent } from './train-part-dialog/train-part-dialog.component';



export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp(new AuthConfig({
        tokenName: 'id_token',
        tokenGetter: (
          () => sessionStorage.getItem('id_token')
        ),
        // globalHeaders: [{'Content-Type':'application/json'}],
     }), http, options);
}

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSidenavModule,
    MatSelectModule,
    MatRadioModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatInputModule,
    MatCheckboxModule,
    MatButtonModule,
    MatTabsModule,
    MatIconModule,
    MatDialogModule,
    MatCardModule,
    MatListModule,
    MatTableModule,
    MatSortModule,
    MatAutocompleteModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    Ng2PaginationModule,
    NoopAnimationsModule,
    routing,
    ChartsModule
  ],
  declarations: [
    AppComponent,
    BusListComponent,
    BusDialogComponent,
    HomeComponent,
    MonitoringComponent,
    OrderLogisticalComponent,
    LoginComponent,
    MenuComponent,
    EetComponent,
    KitchenListComponent,
    TrainListComponent,
    TrainCycleListComponent,
    PeakListComponent,
    PeakDialogComponent,
    PeakCopyDialogComponent,
    PeakImportDialogComponent,
    HolidayExceptionListComponent,
    HolidayExceptionDialogComponent,
    ProductListComponent,
    ProductDialogComponent,
    ProductImportDialogComponent,
    ProductImportErrorOverviewComponent,
    UserListComponent,
    UserDialogComponent,
    CompanyListComponent,
    CompanyDialogComponent,
    SupplierListComponent,
    SupplierDialogComponent,
    SettingListComponent,
    GridTemplateComponent,
    FileUploadComponent,
    TrainDialogComponent,
    TrainCycleDialogComponent,
    KitchenDialogComponent,
    SettingDialogComponent,
    SavingDialogComponent,
    LoadingDialogComponent,
    ReceiptDialogComponent,
    TrainCycleProductDialogComponent,
    TrainCycleSortDialogComponent,
    TrainClassListComponent,
    TrainClassDialogComponent,
    TrainPartDialogComponent,
    PdfLinkComponent,
    BusRouteListComponent,
    BusRouteDialogComponent,
    WMatTimePickerComponent,
    WTimeDialogComponent,
    WClockComponent,
    WTimeComponent
  ],
  providers: [
    BusService,
    BusRouteService,
    KitchenService,
    TrainService,
    TrainCycleService,
    TrainCycleExceptionService,
    SupplierService,
    CompanyService,
    PeakService,
    HolidayExceptionService,
    ProductService,
    MonitoringService,
    OrderLogisticalService,
    CurrencyService,
    AuthGuard,
    Globals,
    AuthService,
    UploadService,
    ReportingService,
    SettingService,
    TrainCycleProductService,
    TrainClassService,
    UserService,
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions]
    },
    { provide: LOCALE_ID, useValue: 'cs-CZ' },
    { provide: MAT_PLACEHOLDER_GLOBAL_OPTIONS, useValue: {float: 'always'} }
  ],
  entryComponents: [
    BusDialogComponent,
    BusRouteDialogComponent,
    TrainDialogComponent,
    TrainCycleDialogComponent,
    KitchenDialogComponent,
    PeakDialogComponent,
    PeakCopyDialogComponent,
    PeakImportDialogComponent,
    HolidayExceptionDialogComponent,
    ProductDialogComponent,
    ProductImportDialogComponent,
    ProductImportErrorOverviewComponent,
    CompanyDialogComponent,
    SupplierDialogComponent,
    UserDialogComponent,
    SettingDialogComponent,
    SavingDialogComponent,
    LoadingDialogComponent,
    ReceiptDialogComponent,
    TrainCycleProductDialogComponent,
    TrainCycleSortDialogComponent,
    TrainClassDialogComponent,
    TrainPartDialogComponent,
    WMatTimePickerComponent,
    WTimeDialogComponent,
    WClockComponent,
    WTimeComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(
    public appRef: ApplicationRef,
    private _compiler: Compiler) {

      let cacheKey = localStorage.getItem('timestamp');
      if (cacheKey !== process.env.TIMESTAMP) {
        this._compiler.clearCache();
        console.log('cache flushed');
        localStorage.setItem('timestamp', process.env.TIMESTAMP);
      }
  }
  hmrOnInit(store) {
    console.log('HMR store', store);
  }
  hmrOnDestroy(store) {
    let cmpLocation = this.appRef.components.map(cmp => cmp.location.nativeElement);
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }
  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/app.module.ts